import { render, staticRenderFns } from "./SwiperMultipleSlides.vue?vue&type=template&id=35ce5f5b&"
import script from "./SwiperMultipleSlides.vue?vue&type=script&lang=js&"
export * from "./SwiperMultipleSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports